(function ($, undefined) {
	'use strict';
	var formValidator;
	var locationsUtils;
	var utils;

	var init = function () {
		formValidator = Fw.component.models().form;
		locationsUtils = Fw.component.models().locationsUtils;
		utils = Fw.component.models().utils;
		$(".send-response-btn.stool-shared-popup-btn").on("click",openPopup);
		$(document).on('click','#add-series',enableRangeInputs);
	};

	var enableRangeInputs=function(e){
		$("#nfc-popup-input-name").parent().parent().addClass(e.currentTarget.checked?"d-none":"d-block").removeClass(e.currentTarget.checked?"d-block":"d-none");
		$("#nfc-popup-input-code").parent().parent().addClass(e.currentTarget.checked?"d-none":"d-block").removeClass(e.currentTarget.checked?"d-block":"d-none");

		$("#nfc-popup-input-name").parent().parent().val("");
		$("#nfc-popup-input-code").parent().parent().val("");

		if(e.currentTarget.checked){
			$("#nfc-popup-input-name").removeAttr("required");
			$("#nfc-popup-input-code").removeAttr("required");
		}else{
			$("#nfc-popup-input-name").attr("required","true");
			$("#nfc-popup-input-code").attr("required","true");
		}

		$("#nfc-popup-input-name").addClass(e.currentTarget.checked?"":"required").removeClass(e.currentTarget.checked?"required error":"");
		$("#nfc-popup-input-code").addClass(e.currentTarget.checked?"":"required").removeClass(e.currentTarget.checked?"required error":"");
		
		if(e.currentTarget.checked){
			var prefix=$(".range-input-template").clone();
			prefix.removeClass("range-input-template d-none").addClass("range-input d-block");
			prefix.find(".form-input-label>span").text("Prefix i.e: Enter \"K23-\" to get K23-0001");
			prefix.find("input").attr("id","prefix");
			prefix.find("input").val("");

			var addZeros=$(".range-input-template").clone();
			addZeros.removeClass("range-input-template d-none").addClass("range-input d-block");
			addZeros.find(".form-input-label>span").text("Add zeros. i.e: Enter \"4\" to get 0001 code (Default value is \"4\")");
			addZeros.find("input").attr("id","addZeros");
			addZeros.find("input").val("4");

			var startRange=$(".range-input-template").clone();
			startRange.removeClass("range-input-template d-none").addClass("range-input d-block");
			startRange.find(".form-input-label>span").text("Start Range *");
			startRange.find("input").attr("id","startRange");
			startRange.find("input").attr("required","true");
			startRange.find("input").val("");

			var endRange=$(".range-input-template").clone();
			endRange.removeClass("range-input-template d-none").addClass("range-input d-block");
			endRange.find(".form-input-label>span").text("End Range *");
			endRange.find("input").attr("id","endRange");
			endRange.find("input").attr("required","true");
			endRange.find("input").val("");

			$(".form-box__form-container").prepend(endRange);
			$(".form-box__form-container").prepend(startRange);
			$(".form-box__form-container").prepend(addZeros);
			$(".form-box__form-container").prepend(prefix);
		}else $(".range-input").remove();
	}
	var openPopup = function(p) {
		var btn = $(this);
		
		var dataItemType= btn.attr('data-item-type');
		
		if(dataItemType=="settings-subscription"){
			var field= $("input[name='subscribers']").val();
			var inputData= field.split("-,").length>1?field.split("-,")[1]:"";
			let checkbox =$(".stool-shared-popup.stool-shared-popup-outer").find('.response-forward__person-check');
			checkbox.map((i, c) => {
				c.checked=String(field).includes(c.value);
			}).get();

			$(".input.response-forward__email").val(inputData);
			
		}else if(dataItemType=="settings-shift-report" || dataItemType=="settings-incident-report"){
			var dataItemGid= btn.attr('data-item-gid');
			
			let checkbox =$(".stool-shared-popup.stool-shared-popup-outer").find('.response-forward__person-check');

			utils.fetchGenDatas({ id:dataItemGid, json: true },gds => {
				if (typeof gds == 'object') {
					var field= dataItemType=="settings-shift-report"?gds[0].field30:gds[0].field27;
					var inputData= field.split("-,").length>1?field.split("-,")[1]:"";

					checkbox.map((i, c) => {
						c.checked=String(field).includes(c.value);
					}).get();
					$(".input.response-forward__email").val(inputData);
				}
			});
		}else if(dataItemType=="shift" || dataItemType=="incident"){
			let checkbox =$(".stool-shared-popup.stool-shared-popup-outer").find('.response-forward__person-check');
			checkbox.map((i, c) => {
				c.checked=false;
			}).get();
			$(".input.response-forward__email").val("");
		}
	}
	
	$(window).ready(function () {
		init();
	});
})(jQuery);